import React, { useState } from 'react';
import style from './style.module.scss';
import { dateFormatter, formatCurrency } from "../../../../../../../../components/helper/helper";
import VisaIcon from '../../../../../../../assets/svg/icons/cards/VisaIcon';

// Card image mapping
const CARD_IMAGES = {
  "Visa": "/images/visa24x24.svg",
  "Mastercard": "/images/master24x24.svg",
  "Amex": "/images/amex24x24.svg",
  "Discover": "/images/discover24x24.svg",
  "Debit": "/images/debit24x24.svg",
  "EBT": "/images/ebt24x24.svg",
};

const Row = ({ data }) => {
  return (
    <>
      <tr className={style.table_row}>
        <td className={`${style.table_cell} ${style.padding_left}`}>{data?.card_number}</td>
        <td className={`${style.table_cell} ${style.card_type}`}>
          <img src={CARD_IMAGES[data?.card_type]} className={style.cardIcon} />
          {data?.card_type}
        </td>
        <td className={style.table_cell}>{data?.retrieval_post_date ? dateFormatter(data?.retrieval_post_date) : '-'}</td>
        <td className={style.table_cell}>{data?.batch_date ? dateFormatter(data?.batch_date) : '-'}</td>
        <td className={style.table_cell}>{data?.reference_number}</td>
        <td className={`${style.table_cell} ${style.text_danger}`}>$ {formatCurrency(data?.transaction_amount)}</td>
        <td className={style.table_cell}>
          {data?.days_to_respond !== null && data?.days_to_respond < 4 && (
            <span className={style.badgeDanger} >
              {data?.days_to_respond + 'days' ?? '-'}
            </span>
          )}

          {data?.days_to_respond >= 4 && data?.days_to_respond < 8 && (
            <span className={style.badgeWarning} >
              {data?.days_to_respond + 'days' ?? '-'}
            </span>
          )}

          {data?.days_to_respond >= 8 && (data?.days_to_respond + 'days' ?? '-')}
        </td>
        <td className={style.table_cell}>{data?.responded_date ? dateFormatter(data?.responded_date) : '-'}</td>
        <td className={style.table_cell}>{data?.reason}</td>
      </tr>
    </>
  );
}

export default Row